import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedVideos from './components/FeaturedVideos';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import { OrganizationLD, WebSiteLD, WebPageLD } from '@/components/base/SEO';

export default function Home() {
  useEffect(() => {
    document.title = '桔子视频-西瓜视频免费在线观看高清全集 | 西瓜视频丝瓜视频不缓冲电视剧大全';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '桔子视频提供西瓜视频免费在线观看服务，西瓜视频、丝瓜视频高清全集不缓冲，电视剧大全电影免费看，满足您对高清视频资源的最新搜索需求。桔子视频,西瓜视频免费,西瓜视频,丝瓜视频,高清在线观看,全集,不缓冲,电视剧大全,免费');
    }
  }, []);

  return (
    <>
      <OrganizationLD />
      <WebSiteLD />
      <WebPageLD
        name="桔子视频-西瓜视频免费在线观看高清全集"
        description="桔子视频提供西瓜视频免费在线观看服务，西瓜视频、丝瓜视频高清全集不缓冲，电视剧大全电影免费看。"
        url="https://juzivideo.com/"
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <HeroSection />
            <CategoryGrid />
            <FeaturedVideos />
            <ArticleSection />
            <FAQSection />
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}